import { useCallback } from "react";
import { FormAction } from "src/components/Form/Form.types.ts";
import { isNotFoundError } from "src/lib/axios/axios.utils.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useSetTabTitle } from "src/system/useSetTabTitle.ts";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import type { StorageKey } from "@exonn/storage";

const defaultGetTabTitle = (resource: any): string => resource?.title;
export const useResourceFormHandlers = ({
  resource,
  type,
  id,
  getTabTitle = defaultGetTabTitle,
  storageKey,
}: {
  resource: string;
  type: FormAction;
  id: string;
  storageKey: StorageKey;

  getTabTitle?: (
    resource: any,
    t: TFunction,
  ) => string | number | null | undefined;
}) => {
  const { t } = useTranslation();

  const setTabTitle = useSetTabTitle({
    storageKey,
  });

  const handleSuccess = useCallback(
    (data: any) => {
      if (type === FormAction.Edit && data?.data) {
        const title = getTabTitle(data.data, t);

        setTabTitle({
          id: id!,
          title: String(title ?? ""),
        });
      }
    },
    [id, resource, setTabTitle, t, type, getTabTitle],
  );

  const handleError = useCallback(
    (error: Error) => {
      if (type === FormAction.Edit && isNotFoundError(error)) {
        setTabTitle({
          id: id!,
          title: t("not-found", {
            ns: TranslationNamespaceEnum.Common,
          }),
        });
      }
    },
    [id, setTabTitle, t, type],
  );
  return {
    handleSuccess,
    handleError,
  };
};
